import useIsMobile from "../hooks/useIsMobile";

import "./BackedBy.css";

import PolychainCapital from "../imgs/PolychainCapital.svg";
import YZiLabs from "../imgs/YZiLabs.svg";
import NomadCapital from "../imgs/NomadCapital.svg";
import IOSG from "../imgs/IOSG.svg";
import Bankless from "../imgs/Bankless.svg";
import Hashey from "../imgs/Hashey.svg";
import Geekcartel from "../imgs/Geekcartel.svg";

function BackedBy() {
  const { isMobile } = useIsMobile();

  return (
    <div className="BackedBy" id="BackedBy">
      <div className="pageTitle">Backed By</div>
      {isMobile ? (
        <div className="BackedByImgListMobile">
          <div className="BackedByImgListMobileItem">
            <img
              src={PolychainCapital}
              className="BackedByTopImgMobile"
              alt="icon"
            />
          </div>
          <div className="BackedByImgListMobileItem">
            <img src={YZiLabs} className="BackedByTopImgMobile" alt="icon" />
          </div>
          <div className="BackedByImgListMobileItem">
            <img
              src={NomadCapital}
              className="BackedByTopImgMobile"
              alt="icon"
            />
          </div>
          <div className="BackedByImgListMobileItem">
            <img src={IOSG} className="BackedByTopImgMobile" alt="icon" />
          </div>
          <div className="BackedByImgListMobileItem">
            <img src={Bankless} className="BackedByTopImgMobile" alt="icon" />
          </div>
          <div className="BackedByImgListMobileItem">
            <img src={Hashey} className="BackedByTopImgMobile" alt="icon" />
          </div>
          <div className="BackedByImgListMobileItem">
            <img src={Geekcartel} className="BackedByTopImgMobile" alt="icon" />
          </div>
        </div>
      ) : (
        <div>
          {" "}
          <div className="BackedByTop">
            <div className="BackedByTopOne">
              <div className="BackedByTopOneTitle">Lead Investors</div>
            </div>
            <div className="BackedByTopBig">
              <div className="BackedByTopTitle2">01</div>
              <img
                src={PolychainCapital}
                className="BackedByTopImg2"
                alt="icon"
              />
            </div>
            <div className="BackedByTopBig">
              <div className="BackedByTopTitle2">02</div>
              <img src={YZiLabs} className="BackedByTopImg2" alt="icon" />
            </div>
          </div>
          <div className="BackedByTop">
            <div className="BackedByTopOne">
              <div className="BackedByTopOneTitle">More Investors</div>
            </div>
            <div className="BackedByTopBig">
              <div className="BackedByTopTitle2">03</div>
              <img src={NomadCapital} className="BackedByTopImg" alt="icon" />
            </div>
            <div className="BackedByTopBig">
              <div className="BackedByTopTitle2">04</div>
              <img src={IOSG} className="BackedByTopImg" alt="icon" />
            </div>
            <div className="BackedByTopBig">
              <div className="BackedByTopTitle2">05</div>
              <img src={Bankless} className="BackedByTopImg" alt="icon" />
            </div>
            <div className="BackedByTopBig">
              <div className="BackedByTopTitle2">06</div>
              <img src={Hashey} className="BackedByTopImg" alt="icon" />
            </div>
            <div className="BackedByTopBig">
              <div className="BackedByTopTitle2">07</div>
              <img src={Geekcartel} className="BackedByTopImg" alt="icon" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BackedBy;
